const listeners = new Set();

function dispatch(type, message) {
  listeners.forEach(fn => fn({ type, message, id: Date.now() + Math.random() }));
}

const toast = {
  success: (msg) => dispatch('success', msg),
  error: (msg) => dispatch('error', msg),
  info: (msg) => dispatch('info', msg),
  subscribe: (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};

export default toast;
